/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState } from "react";
import { TermListTableContext } from "../TermListTable";
import { Form } from "react-bootstrap";
import languages from '../../config/languages.json';
import { producerOptions } from "../../config/config";

export const RenderFilter = ({ type }) => {
    switch (type) {
        case "referenceId": return <ReferenceIdFilter />
        case "lemma": return <LemmaFilter />
        case "posTagging": return <PosTaggingFilter />
        case "expansion": return <ExpansionFilter />
        case "nth_head": return <NthHeadFilter />
        case "label": return <DatasetLabelFilter />
        case "language": return <LanguageFilter />
        case "vedette_class": return <IsVedetteFilter />
        case "classes": return <IsSemanticFilter />
        case "engine": return <EngineFilter />
        case "user_vote": return <ValidationFilter />
        case "status": return <FinalValidationFilter />
        case "n_doc": return <NbDocsFilter />
        case "occurences": return <NbOccFilter />
        case "words": return <NbWordsFilter />

        default: return <div className="m-1" style={{ height: "33px" }}></div>;
    }
}

const inputStyle = (value, type) => ({
    backgroundColor: (type === "option" ? Number(value) !== 0 : value?.length > 0)
        ? '#eaf8ea'
        : 'white',
});

const ReferenceIdFilter = () => {
    const { surfaceRegex, setSurfaceRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(surfaceRegex);

    useEffect(() => {
        setLocalValue(surfaceRegex);
    }, [surfaceRegex]);

    const setSurfaceRegex_ = useCallback(
        debounce((query) => {
            setSurfaceRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(surfaceRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setSurfaceRegex_(target.value);
        }}
    />
}

const LemmaFilter = () => {
    const { lemmaRegex, setLemmaRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(lemmaRegex);

    useEffect(() => {
        setLocalValue(lemmaRegex);
    }, [lemmaRegex]);

    const setLemmaRegex_ = useCallback(
        debounce((query) => {
            setLemmaRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(lemmaRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setLemmaRegex_(target.value);
        }}
    />
}

const PosTaggingFilter = () => {
    const { postagRegex, setPostagRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(postagRegex);

    useEffect(() => {
        setLocalValue(postagRegex);
    }, [postagRegex]);

    const setPostagRegex_ = useCallback(
        debounce((query) => {
            setPostagRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(postagRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setPostagRegex_(target.value);
        }}
    />
}

const ExpansionFilter = () => {
    const { expRegex, setExpRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(expRegex);

    useEffect(() => {
        setLocalValue(expRegex);
    }, [expRegex]);

    const setExpRegex_ = useCallback(
        debounce((query) => {
            setExpRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(expRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setExpRegex_(target.value);
        }}
    />
}

const NthHeadFilter = () => {
    const { headRegex, setHeadRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(headRegex);

    useEffect(() => {
        setLocalValue(headRegex);
    }, [headRegex]);

    const setHeadRegex_ = useCallback(
        debounce((query) => {
            setHeadRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(headRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setHeadRegex_(target.value);
        }}
    />
}

const DatasetLabelFilter = () => {
    const { producerRegex, setProducerRegex } = useContext(TermListTableContext);
    const [localValue, setLocalValue] = useState(producerRegex);

    useEffect(() => {
        setLocalValue(producerRegex);
    }, [producerRegex]);

    const setProducerRegex_ = useCallback(
        debounce((query) => {
            setProducerRegex(query);
        }, 500),
        []
    );
    return <Form.Control
        style={inputStyle(producerRegex)}
        className="m-1"
        size="sm"
        type="text"
        value={localValue}
        onChange={({ target }) => {
            setLocalValue(target.value);
            setProducerRegex_(target.value);
        }}
    />
}

const LanguageFilter = () => {
    const { languageFilter, setLanguageFilter } = useContext(TermListTableContext);

    return <Form.Control
        style={inputStyle(languageFilter)}
        className="m-1"
        as="select"
        size="sm"
        aria-label="select language"
        value={languageFilter[0]}
        onChange={(e) => (e.target.value?.length > 0 ? setLanguageFilter([e.target.value]) : setLanguageFilter([]))}
    >
        <option value={[]}>Langue...</option>
        {languages.map((language => (
            <option key={Object.keys(language)} value={Object.keys(language)}>{Object.values(language)}</option>
        )))}
    </Form.Control>
}

const IsVedetteFilter = () => {
    const { isVedette, setIsVedette } = useContext(TermListTableContext);

    return <Form.Control
        style={inputStyle(isVedette, "option")}
        className="m-1"
        as="select"
        size="sm"
        aria-label="Vedette"
        value={isVedette}
        onChange={(event) => {
            if (event.target.value === "0") setIsVedette(0)
            else setIsVedette(event.target.value)
        }}
    >
        <option value={0}> - </option>
        <option value={true}> Oui </option>
        <option value={false}> Non </option>
    </Form.Control>
}

const IsSemanticFilter = () => {
    const { inSemantic, setiInSemantic } = useContext(TermListTableContext);

    return <Form.Control
        style={inputStyle(inSemantic, "option")}
        className="m-1"
        as="select"
        size="sm"
        aria-label="Membre de classe"
        value={inSemantic}
        onChange={(event) => {
            if (event.target.value === "0") setiInSemantic(0)
            else setiInSemantic(event.target.value)
        }}
    >
        <option value={0}> - </option>
        <option value={true}> Oui </option>
        <option value={false}> Non </option>
    </Form.Control>
}

const EngineFilter = () => {
    const { producerFilter, setProducerFilter } = useContext(TermListTableContext);

    return <Form.Control
        style={inputStyle(producerFilter)}
        className="m-1"
        as="select"
        size="sm"
        aria-label="select producer"
        value={producerFilter[0]}
        onChange={(e) => (e.target.value?.length > 0 ? setProducerFilter([e.target.value]) : setProducerFilter([]))}
    >
        <option value={[]}>Méthode...</option>
        {producerOptions.map((producerOption => (
            <option key={Object.keys(producerOption)} value={Object.keys(producerOption)}>{Object.values(producerOption)}</option>
        )))}
    </Form.Control>
}

const ValidationFilter = () => {
    const { validationFilter, setValidationFilter } = useContext(TermListTableContext);

    const onChangeValidationFilter = (value) => {
        if (value === '1') setValidationFilter([1])
        else if (value === '-1') setValidationFilter([-1])
        else if (value === '0') setValidationFilter([0])
        else setValidationFilter(value)
    }

    return <Form.Control
        style={inputStyle(validationFilter)}
        className="m-1"
        as="select"
        size="sm"
        aria-label="select validation"
        value={validationFilter[0]}
        onChange={(e) => onChangeValidationFilter(e.target.value)}
    >
        <option value={[]}>Valid...</option>
        <option value={'1'}>Oui</option>
        <option value={'-1'}>Non</option>
        <option value={'0'}>Non-vu</option>
    </Form.Control>
}

const FinalValidationFilter = () => {
    const { finalValidationFilter, setFinalValidationFilter } = useContext(TermListTableContext);

    const onChangeValidationFilter = (value) => {
        if (value === 'true') setFinalValidationFilter([true])
        else if (value === 'false') setFinalValidationFilter([false])
        else if (value === 'non-vu') setFinalValidationFilter(['non-vu'])
        else setFinalValidationFilter(value)
    }

    return <Form.Control
        style={inputStyle(finalValidationFilter)}
        className="m-1"
        as="select"
        size="sm"
        aria-label="select validation"
        value={finalValidationFilter[0]}
        onChange={(e) => onChangeValidationFilter(e.target.value)}
    >
        <option value={[]}>Valid...</option>
        <option value={'true'}>Oui</option>
        <option value={'false'}>Non</option>
        <option value={'non-vu'}>Non-vu</option>
    </Form.Control>
}

const NbDocsFilter = () => {
    const {
        n_doc_gte, setN_doc_gte,
        n_doc_lte, setN_doc_lte
    } = useContext(TermListTableContext);

    const [localGte, setLocalGte] = useState(n_doc_gte ?? "");
    const [localLte, setLocalLte] = useState(n_doc_lte ?? "");

    useEffect(() => {
        setLocalGte(n_doc_gte ?? "");
    }, [n_doc_gte]);

    useEffect(() => {
        setLocalLte(n_doc_lte ?? "");
    }, [n_doc_lte]);

    const setN_doc_gte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setN_doc_gte();
            else setN_doc_gte(query);
        }, 500),
        []
    );

    const setN_doc_lte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setN_doc_lte();
            else setN_doc_lte(query);
        }, 500),
        []
    );

    return <div className="d-flex m-1">
        <Form.Control
            style={inputStyle(n_doc_gte)}
            className="mr-1 min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="min"
            value={localGte}
            onChange={({ target }) => {
                setLocalGte(target.value);
                setN_doc_gte_(target.value);
            }}
            htmlSize={5}
        />
        <Form.Control
            style={inputStyle(n_doc_lte)}
            className="min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="Max"
            value={localLte}
            onChange={({ target }) => {
                setLocalLte(target.value);
                setN_doc_lte_(target.value);
            }}
        />
    </div>
}

const NbOccFilter = () => {
    const {
        occurences_gte, setOccurences_gte,
        occurences_lte, setOccurences_lte
    } = useContext(TermListTableContext);

    const [localGte, setLocalGte] = useState(occurences_gte ?? "");
    const [localLte, setLocalLte] = useState(occurences_lte ?? "");

    useEffect(() => {
        setLocalGte(occurences_gte ?? "");
    }, [occurences_gte]);

    useEffect(() => {
        setLocalLte(occurences_lte ?? "");
    }, [occurences_lte]);

    const setOccurences_gte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setOccurences_gte();
            else setOccurences_gte(query);
        }, 500),
        []
    );

    const setOccurences_lte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setOccurences_lte();
            else setOccurences_lte(query);
        }, 500),
        []
    );

    return <div className="d-flex m-1">
        <Form.Control
            style={inputStyle(occurences_gte)}
            className="mr-1 min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="min"
            value={localGte}
            onChange={({ target }) => {
                setLocalGte(target.value);
                setOccurences_gte_(target.value);
            }}
        />
        <Form.Control
            style={inputStyle(occurences_lte)}
            className="min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="Max"
            value={localLte}
            onChange={({ target }) => {
                setLocalLte(target.value);
                setOccurences_lte_(target.value);
            }}
        />
    </div>
}

const NbWordsFilter = () => {
    const {
        words_gte, setWords_gte,
        words_lte, setWords_lte
    } = useContext(TermListTableContext);

    const [localGte, setLocalGte] = useState(words_gte ?? "");
    const [localLte, setLocalLte] = useState(words_lte ?? "");

    useEffect(() => {
        setLocalGte(words_gte ?? "");
    }, [words_gte]);

    useEffect(() => {
        setLocalLte(words_lte ?? "");
    }, [words_lte]);

    const setWords_gte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setWords_gte();
            else setWords_gte(query);
        }, 500),
        []
    );

    const setWords_lte_ = useCallback(
        debounce((query) => {
            if (query.length === 0) setWords_lte();
            else setWords_lte(query);
        }, 500),
        []
    );

    return <div className="d-flex m-1">
        <Form.Control
            style={inputStyle(words_gte)}
            className="mr-1 min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="min"
            value={localGte}
            onChange={({ target }) => {
                setLocalGte(target.value);
                setWords_gte_(target.value);
            }}
        />
        <Form.Control
            style={inputStyle(words_lte)}
            className="min-width-50"
            size="sm"
            type="number"
            onKeyPress={handleKeyPress}
            min={0}
            placeholder="Max"
            value={localLte}
            onChange={({ target }) => {
                setLocalLte(target.value);
                setWords_lte_(target.value);
            }}
        />
    </div>
}

const handleKeyPress = (e) => {
    if (e.key === '-' || e.key === 'e') {
        e.preventDefault();
    }
};

function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
}